const productData = [
  {
    id: 1,
    name: "eMoney Athletic Tee",
    description: `
    3.7 oz lightweight athletic tee
    100% polyester
    Athletic fit
    Made in USA

    Ships in ~5 days`,
    price: 29.25,
    images: [
      '/tee-front.png',
      '/tee-back.png'
    ],
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    // Shopify Variant IDs: Placeholder - please replace with actual IDs
    // Each size needs its own variant ID if they are distinct products in Shopify
    variants: [
      { id: "50332430893373", size: "XS", price: 29.25 },
      { id: "50332430926141", size: "S", price: 29.25 },
      { id: "50332430958909", size: "M", price: 29.25 },
      { id: "50332430991677", size: "L", price: 29.25 },
      { id: "50332432138557", size: "XL", price: 29.25 },
      { id: "50332432171325", size: "2XL", price: 29.25 }
    ],
    category: "Tee" // Added for easier component differentiation
  },
  {
    id: 2,
    name: "eMoney Hoodie",
    description: `
    60/40 cotton/poly blend
    Performance cut and fit
    Made in USA

    Ships in ~5 days`,
    price: 44.25,
    images: [
      '/hoodie-front.png',
      '/hoodie-back.png'
    ],
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    // Shopify Variant ID: Placeholder - please replace with actual ID
    variants: [
      { id: "50332433056061", size: "XS", price: 44.25 },
      { id: "50332433088829", size: "S", price: 44.25 },
      { id: "50332433121597", size: "M", price: 44.25 },
      { id: "50332433154365", size: "L", price: 44.25 },
      { id: "50332433187133", size: "XL", price: 44.25 },
      { id: "50332433219901", size: "2XL", price: 44.25 }
    ],
    category: "Hoodie" // Added for easier component differentiation
  }
];

export default productData; 